<template>
	<div class="bg-struct bg-struct-details bg-img bg-img-18"></div>
	<div class="main-cont">
		<div class="row align-items-center justify-content-center">
			<div class="col-md-8 col-lg-6 col-xl-5">
				<div class="card shadow-none">
					<div class="card-body text-center p-4">
						<div @click="redirectToAuth()" class="btn btn-primary" v-if="!authModel.isAuth()">Войти</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss"></style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	name: "Login",
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Авторизация | byLex Portfolio'});
	},
	data: () => ({
		
	}),
	methods: {
		redirectToAuth(){
			const redirectUri = window.location.origin;
			const authUrl = 'https://id.bylex.su/login-out?' + new URLSearchParams({
				redirect: redirectUri,
			});
			window.location.href = authUrl;
		},
	},
	mounted(){
		window.scrollTo(0, 0);
	},
	components: {},
};
</script>
